//
//
//
//
//
//
//
//
//
//
//
//

import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import RbPayOverTimePanel from '@/elements/pay-over-time/rb-pay-over-time-panel.vue'
import RbPayOverTimeModal from '@/elements/pay-over-time/rb-pay-over-time-modal.vue'
import RbPanel from '@/elements/panel/rb-panel.vue'

export default {
  name: 'rb-pay-over-time-panel-and-modal',
  components: {
    RbPayOverTimePanel,
    RbPayOverTimeModal,
    RbPanel,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
  },
  mounted() {
    window.externalInvocationMethodMapping.showKlarnaAfterpayModal = () => {
      this.openKlarnaAfterpay()
    }
  },
  methods: {
    close() {
      this.$emit('closed')
    },
  },
}
